module.exports = __webpack_public_path__ + "img/effect2.06a36d5a.png";